import { getDcfExperience, getTncStatus } from 'communicator/store/selectors';
import { CardListRequestPayload, CardListResponse } from 'types/api/card-list';
import { OrchestratorErrorResponse } from 'types/api/orchestrator';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';
import { markEnd, markStart } from '../instrumentation';

type FetchCardListRequest = {
  accessToken?: string;
  payload: CardListRequestPayload;
};

export function fetchCardList({
  accessToken,
  payload
}: FetchCardListRequest): FetchResponse<CardListResponse, OrchestratorErrorResponse> {
  const headers: Record<string, string> = {};
  const body: CardListRequestPayload = { ...payload };
  const dcfExperience = getDcfExperience();
  const isTnc = getTncStatus() === 'not_accepted';
  let url = endpoints.orchestrator.prepare;

  if (dcfExperience) {
    url += `?dcfExperience=${dcfExperience}`;
  }

  if (accessToken && !isTnc) {
    headers.access_token = accessToken;
  }

  markStart('gsp_orch_card_list');
  return fetchReq({
    body,
    headers,
    mark: 'gsp_orch_card_list',
    method: 'POST',
    url
  }).then(res => {
    markEnd('gsp_orch_card_list');
    return res;
  });
}
